import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { UrlTree, Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { SessionService } from '../session-service.service'

@Injectable({
  providedIn: 'root',
})
export class ConfigGuard implements CanActivate {
  constructor(private sessionService: SessionService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const { params } = route
    if (
      params.intermediaryId !== undefined &&
      (params.intermediaryId !== this.sessionService.getIntermediaryId() ||
        params.productType !== this.sessionService.getProductType() ||
        params.locale !== this.sessionService.getLocale())
    ) {
      return this.sessionService.loadConfigSettings(params)
    }
    return true
  }
}